import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprData } from 'shell/models/person';
import { transformPerson } from 'shell/utils/consult-person/response-transformer/person/person';
import { CancelCivilUnionFormVM } from 'mutation/view-models/cancel-civil-union';
import { CivilUnionVM } from 'mutation/view-models/civil-union';
import { CivilStatusID } from 'shell/constants/civil-status';
import { transformCivilStatus } from 'shell/utils/consult-person/response-transformer/marital-status/civil-status';
import { DateTime } from 'luxon';
import { transformFamilyCoexistence } from 'shell/utils/consult-person/response-transformer/family/family-coexistence';
import { transformCitizenship } from 'shell/utils/consult-person/response-transformer/registry-office/citizenship';
import { emptyDigital, emptyPaper } from 'shell/components/shared/act/constants';
import { ActType } from 'shell/constants/act-type';
import { transformCivilUnionActAnpr05 } from 'shell/utils/consult-person/response-transformer/marital-status/civil-union-act-anpr05';

export const checkPersonCancelCivilUnion = (civilStatus: string | undefined): boolean => {
  if (civilStatus && civilStatus !== CivilStatusID.unitoCivilmente) {
    return false;
  }

  return true;
};

export const transformerCancelCivilUnionData = (
  response: AxiosResponse<HttpResponse<ResponseAnprData>>
): CancelCivilUnionFormVM => {
  const [person] = response.data?.payload?.risposta3002OK?.listaSoggetti.datiSoggetto || [];

  const personData = transformPerson(person || {});

  const civilStatus = transformCivilStatus(person);

  const familyCoexistence = transformFamilyCoexistence(person);

  const citizenship = transformCitizenship(person);

  let civilUnion: CivilUnionVM | undefined = undefined;

  if (!person?.unioneCivile?.scioglimentoUnione?.motivoScioglimento) {
    const civilUnionAnpr05 = transformCivilUnionActAnpr05(person || {});
    // scioglimento non avvenuto
    civilUnion = civilUnionAnpr05
      ? {
          ...civilUnionAnpr05,
          dateEvent: civilUnionAnpr05.eventDate,
          dateEventChoice: civilUnionAnpr05.eventChoiceDate,
          person: civilUnionAnpr05.person || undefined,
          italian: civilUnionAnpr05?.italian
            ? {
                locality: civilUnionAnpr05.italian.location,
                municipality: civilUnionAnpr05.italian.municipality,
              }
            : undefined,
          foreign: civilUnionAnpr05?.foreign
            ? {
                municipalityForeign: civilUnionAnpr05.foreign.municipality,
                provinceForeign: civilUnionAnpr05.foreign.province,
                foreignState: civilUnionAnpr05.foreign.state,
              }
            : undefined,
          digital: civilUnionAnpr05?.digital || undefined,
        }
      : undefined;
  }

  return {
    person: personData,
    familyCoexistence,
    citizenship,
    editDataControl: {
      dateValidity: DateTime.now(),
    },
    civilStatus: {
      ...(civilStatus || {}),
      oldStatus: civilStatus?.status,
      status: CivilStatusID.scioglimentoUnitoCivilmente,
    },
    civilUnion,
    cancelCivilUnion: {
      eventDate: null,
      reasonCancel: '',
      paper: emptyPaper,
      digital: emptyDigital,
      actType: ActType.AttoCartaceo,
    },
  };
};
